export default [
    {
        field: 'name',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Nombre',
        },
        rules: ['required'],
    },
]
